import ManualAssignment from "./ManualAssignment";

export default ManualAssignment;
